export default __webpack_public_path__ + "static/media/CFD.461345b1.mp4";